{
  "enum": {
    "IxmTriggerV1TriggerStatus": {
      "ACTIVE": "Active",
      "ARCHIVED": "Archived",
      "PAUSED": "Paused",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxmTriggerV1TriggerQueryServiceTriggerListFilterableFields": {
      "status": "Status",
      "triggerId": "Trigger"
    }
  },
  "oneOf": {
    "IxmTriggerV1Payload": {
      "static": "Static"
    },
    "IxmTriggerV1TriggerEventType": {
      "activated": "Activated",
      "archived": "Archived",
      "manuallyTriggered": "Manually Triggered",
      "paused": "Paused",
      "triggered": "Triggered",
      "upserted": "Upserted"
    }
  },
  "sortEnum": {
    "IxmTriggerV1TriggerQueryServiceTriggerListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}